import React from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Background from './Background';
import { LayoutProps } from '../types';

interface ExtendedLayoutProps extends LayoutProps {
  backgroundImage?: string;
}

const Layout: React.FC<ExtendedLayoutProps> = ({
  children,
  showBackground = false,
  backgroundImage,
}) => {
  // embed=1 — iframe 임베드(예: D건 Preview). 앱 크롬(헤더/푸터) 숨겨 출력 화면만 노출.
  const [searchParams] = useSearchParams();
  const embed = searchParams.get('embed') === '1';

  const content = (
    <div className="h-dvh flex flex-col overflow-hidden">
      {!embed && <Header />}
      {/* 고정 헤더/푸터 높이 + safe-area 만큼 본문을 밀어냄 (vh 고정값은 낮은 뷰포트에서 헤더에 가려졌음) */}
      <main className={`flex-1 flex flex-col min-h-0 ${embed ? '' : 'pt-[calc(var(--app-header-h)+env(safe-area-inset-top))]'}`}>
        <div className={`flex-1 min-h-0 overflow-y-auto flex flex-col ${embed ? '' : 'pb-[calc(var(--app-footer-h)+env(safe-area-inset-bottom))]'}`}>
          {children}
        </div>
      </main>
      {!embed && <Footer />}
    </div>
  );

  if (showBackground) {
    return (
      <Background image={backgroundImage}>
        {content}
      </Background>
    );
  }

  return content;
};

export default Layout;